(function () {
  'use strict';

  angular.module('app.pathAdvisor')
    .directive('pathAdvisorSrcdoc', [function () {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          scope.$watch(attrs.pathAdvisorSrcdoc, function (html) {
            element[0].srcdoc = html || '';
          });
        }
      };
    }])
    .controller('PathAdvisorDetailsController', [
      'APP_CONSTANTS',
      'toaster',
      '$stateParams',
      'PathAdvisorService',
      'FileSaver',
      PathAdvisorDetailsController
    ]);

  function PathAdvisorDetailsController(
    APP_CONSTANTS,
    toaster,
    $stateParams,
    PathAdvisorService,
    FileSaver,
  ) {
    var vm = this;
    vm.loading = {};
    vm.profileHtml = '';

    loadProfileHtml();

    function loadProfileHtml() {
      vm.loading.profile = true;
      PathAdvisorService.generatePathAdvisorProfileHtml($stateParams.discovererId)
        .then(function (response) {
          vm.profileHtml = _.get(response, 'data.html', '');
          if (!vm.profileHtml) toaster.pop('error', APP_CONSTANTS.MESSAGE.dataNotFound);
        })
        .catch(function (error) {
          toaster.pop('error', _.get(error, 'data.message') || error.statusText);
        })
        .finally(function () {
          vm.loading.profile = false;
        });
    }

    vm.exportToPdf = (operation) => {
      vm.loading.export = true;

      PathAdvisorService
        .generatePathAdvisorProfilePdf($stateParams.discovererId)
        .then((response) => {
          const file = new Blob([response.data], { type: 'application/pdf' });
          const disposition = response.headers('content-disposition') || '';
          const filename = disposition.match(/filename="?([^";]+)"?/i)?.[1] || 'Path-Advisor-Report.pdf';

          if (operation === APP_CONSTANTS.PDF_OPERATION.DOWNLOAD) {
            FileSaver.saveAs(file, filename);
          } else {
            var fileURL = window.URL.createObjectURL(file);
            printPage(file, fileURL, filename);
          }
        })
        .catch((error) => {
          toaster.pop('error', error.data.message || error.statusText);
        })
        .finally(() => {
          vm.loading.export = false;
        });
    }

    function printPage(file, fileURL, filename) {
      var isFirefox = typeof InstallTrigger !== 'undefined';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        return window.navigator.msSaveOrOpenBlob(file, filename);
      } else if (isFirefox) {
        window.open(fileURL, '_blank');
      } else {
        var oHiddFrame = document.createElement('iframe');

        oHiddFrame.onload = setPrint;
        oHiddFrame.style.visibility = 'hidden';
        oHiddFrame.style.position = 'fixed';
        oHiddFrame.style.right = '0';
        oHiddFrame.style.bottom = '0';
        oHiddFrame.src = fileURL;
        document.body.appendChild(oHiddFrame);
      }
    }

  }
})();
